module.exports = __webpack_public_path__ + "img/what10.688a9304.png";